/**
 * Formats a string by capitalizing the first letter and replacing underscores with spaces.
 * 
 * @param {string} str - The string to format. If not provided, defaults to an empty string.
 * @returns {string} - Returns the formatted string with the first letter capitalized and underscores replaced by spaces.
 */
const formatString = (str = '') => {
	return String(str).charAt(0).toUpperCase() + String(str).slice(1).replace(/_/g, ' ');
};

export default formatString;
